import i18n from '@/i18n'

export const noneOption = () => ({
  value: 'none',
  label: i18n.t('text.none-option', { ns: 'common' })
})
